module.exports = __webpack_public_path__ + "static/media/contact-map-2x.8eb13e5b.png";